import React from 'react';
import Breadcrumb from '../../components/breadcrumb/breadcrumb';
import Sidebar from '../../components/sidebar/sidebar';
import DetailedProduct from '../../components/product/detailedProduct';
import DetailsHeading from '../../components/detailsHeading/detailsHeading';
import CardIngredients from '../../components/card/cardIngredients';
import CardNutritional from '../../components/card/cardNutritional';
import SuggestedProductsHeading from '../../components/product/suggestedProductsHeading';
import DiscoverProduct from '../../components/product/discoverProduct';
import HorizontalMenu from '../../components/sidebar/horizontalMenu';
import RotatingDiv from '../../components/rotatingDiv/rotatingDiv';

//import product images
import originalberry from '../../images/products/originalberry.png';
import originaljam from '../../images/products/original.png';
import extra from '../../images/products/extra.png';
import berriesSauce from '../../images/products/berries-sauce.png';

function BerriesSauce() {
    const suggestions = [
        {
            name: 'Doce de Physalis',
            photo: originaljam,
            link: '/originaljam',
            className: 'physalina-link',
        },
        {
            name: 'Compota Extra de Physalis',
            photo: extra,
            link: '/originalextrajam',
            className: 'physalina-link',
        },
        {
            name: 'Bagas desidratadas',
            photo: originalberry,
            link: '/originalberry',
            className: 'physalina-link',
        },
    ];

    return (
        <>
            <div className="horizontal-menu">
                <HorizontalMenu />
            </div>
            <div className="breadcrumb-container">
                <Breadcrumb
                    home="Home"
                    section="Produtos"
                    category="Bagas de Physalis"
                    name="Bagas em Calda"
                ></Breadcrumb>
            </div>
            <div className="product-details-grid">
                <div className="sidebar-menu padding-top30 padding-left50">
                    <Sidebar />
                </div>
                <DetailedProduct
                    photo={berriesSauce}
                    name="Bagas em Calda"
                    color="orange-text"
                    category="Bagas de Physalis"
                    description="Estas bagas de physalis em calda, de textura única e com aroma ligeiro a hortelã, são de uma suavidade que dá vontade de saborear, são ótimas para enriquecer e aromatizar saladas de frutas, cobertura de sericaia, bolos, cheesecakes ou panna cotta."
                    weight="Frasco de 200ml / Peso escorrido 100g"
                    link="/contacts"
                    buttonColor="btn--original"
                    buttonText="Online"
                ></DetailedProduct>
                <div className="details">
                    <div className="details-title">
                        <DetailsHeading
                            text="Detalhes"
                            type="original"
                        ></DetailsHeading>
                    </div>
                    <div className="cards">
                        <div className="card-ingridients-container">
                            <CardIngredients
                                sugar="yes"
                                sulfitos="yes"
                                specialIngredient="Água"
                                secondSpecialIngredient="Hortelã (Mentha spicata)"
                            ></CardIngredients>
                            <RotatingDiv>
                                <div className="svg-original-berry solid-pattern-container"></div>
                            </RotatingDiv>
                        </div>
                        <div className="card-nutritional-container">
                            <CardNutritional
                                energy="1055 kj / 252 kcal"
                                lipids="0.12 g"
                                saturados="0.00 g"
                                hydrates="60.57 g"
                                sugars="56.40 g"
                                fiber="2.44 g"
                                proteins="2.14 g"
                                salt="0.14 g"
                            ></CardNutritional>
                            <RotatingDiv>
                                <div className="svg-original-berry solid-pattern-container2"></div>
                            </RotatingDiv>
                        </div>
                    </div>
                </div>
                <div className="suggestions-heading">
                    <SuggestedProductsHeading
                        question="É fã do sabor original da Physalis?"
                        answer="Originalidade é connosco:"
                        color="orange-text"
                    ></SuggestedProductsHeading>
                </div>
                <div className="discover-section-grid">
                    {suggestions.map((discoverProduct, idx) => (
                        <DiscoverProduct
                            key={idx}
                            discoverProduct={discoverProduct}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

export default BerriesSauce;
